// src/pages/TimelinePage.tsx
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import OrderDetails from "../orders/OrderDetails";
import { getReservations } from "../services/reservation-service";
import { CalendarEvent } from "../calendar/calendar-types";
import { startOfDay } from "date-fns";

interface Props {
    onSave?: (updatedEvent: CalendarEvent) => void;
}

const ReservationTimeline: React.FC<Props> = ({ onSave }) => {

  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [row, setRow] = useState({} as CalendarEvent)
  const [data, setData] = useState([] as CalendarEvent[])

  useEffect(() => {

    // data for future 30 days
    const thirtyDaysFromNow = new Date();
    thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);

    getReservations(startOfDay(new Date()), thirtyDaysFromNow).then((response) => {
      const filteredData = response.filter(item => new Date(item.start) > new Date()).slice(0, 5);
      setData(filteredData);
    });
  }, []);

  const handleOpen = (e: React.MouseEvent, row: any) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true)
    setRow(row)
  } 

  return (
    <Card>
        <CardHeader className="flex items-center justify-between">
            <CardTitle>Upcoming Reservations</CardTitle>
            <Button onClick={() => navigate("/reservations")} className="py-1 px-2">View all</Button>
        </CardHeader>
      <CardContent>
        {data.map((item, index) => (
          <div key={item.id} className="relative grid mt-3">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-medium text-base">{(item.customerName || '') + (` ${item.customerEmail || item.customerPhone}` || '')}</h4>
                <p className="text-sm text-muted-foreground">{new Date(item.start).toLocaleString()} - {new Date(item.end).toLocaleString()}</p>
              </div>
              <div className="mt-2">
                <Button onClick={(e: React.MouseEvent) => handleOpen(e, item)} size="sm" variant="outline">View</Button>
              </div>
            </div>
          </div>
        ))}
        {data?.length === 0 && <p className="text-center text-lg text-medium">No result</p>}
        <OrderDetails selectedOrder={row} isSheetOpen={open} setIsSheetOpen={setOpen} onSave={(updatedEvent) => {

          setData((prevData) => prevData.map((item) => item.id === updatedEvent.id ? updatedEvent : item));
          onSave?.(updatedEvent);
        }} />

      </CardContent>
    </Card>
  );
}

export default ReservationTimeline;
